<template>
  <fin-autocomplete :instant-clear-selection="instantClearSelection"
                    :resolver="searchAssets"
                    clearable
                    :autofocus="autofocus"
                    :value="value"
                    :item-disabled="itemDisabled"
                    no-data-text-no-search-keyword="Bitte Namen oder ISIN eingeben"
                    placeholder="Suche über den Namen oder ISIN"
                    @input="(val) => autocompleteSelection(val)">
    <template #item="{item}">
      {{ item.name }} ({{ item.isin }})
    </template>

  </fin-autocomplete>
</template>

<script>
import FinAutocomplete from "@/components/common/Autocomplete"
import {
  searchSharesByNameOrISIN,
  searchEtfsByNameOrISIN,
  searchAllByNameOrISIN,
  DEFAULT_ITEM, searchIndicesByNameOrISIN, DEFAULT_SHARE_ETF_ITEM
} from "@/components/common/AssetsNameIsinAutocomplete/graphql"
import {API, graphqlOperation} from "@/plugins/finAmplifyModules"

export default {
  name: "finAssetsNameIsinAutocomplete",
  components: {FinAutocomplete},
  props: {
    /** The value object */
    value: {
      type: Object,
      default: null
    },
    /** Set if the selection should be instantly cleared */
    instantClearSelection: {
      type: Boolean,
      default: false
    },
    /** Customize the returned object, default: id isin name assetClass */
    customReturnItem: {
      type: String,
      default: null
    },
    /** Specify the asset type to search for */
    assetType: {
      type: String,
      default: 'SHARE'
    },
    /** Extend the default name or isin search for additional and combined attributes */
    customSearchAndFilter: {
      type: String,
      default: ''
    },
    /** Used to set if an item is disabled, can be string, array or function */
    itemDisabled: {},
    /** Option to specify a custom result items mapper function */
    customResultMapping: {
      type: Function
    },
    /** If component should automatically get focus when the page loads */
    autofocus: {
      type: Boolean
    },
  },
  methods: {
    async searchAssets({searchKeyword, from}) {
      const returnItem = this.customReturnItem ? this.customReturnItem : (this.assetType === 'SHARE' || this.assetType.indexOf('ETF') !== -1 || this.assetType === 'ALL') ? DEFAULT_SHARE_ETF_ITEM : DEFAULT_ITEM

      let searchQuery
      let resultObjName
      if (!this.assetType || this.assetType === 'SHARE') {
        searchQuery = searchSharesByNameOrISIN
        resultObjName = 'searchShares'
      } else if (this.assetType.indexOf('ETF') !== -1) {
        searchQuery = searchEtfsByNameOrISIN
        resultObjName = 'searchEtfs'
      } else if (this.assetType === 'INDEX') {
        searchQuery = searchIndicesByNameOrISIN
        resultObjName = 'searchIndexs'
      } else if (this.assetType === 'ALL') {
        searchQuery = searchAllByNameOrISIN
        resultObjName = 'searchInstruments'
      } else {
        return []
      }

      searchQuery = searchQuery.replaceAll('$returnItem', returnItem)
      searchQuery = searchQuery.replace('$optionalAndFilters', this.customSearchAndFilter)

      let result = await API.graphql(graphqlOperation(searchQuery, {
        limit: 20,
        from,
        searchKeyword: searchKeyword
      }))

      const resultItems = result.data[resultObjName].items
      return this.customResultMapping ? this.customResultMapping(resultItems) : resultItems

    },
    autocompleteSelection(val) {
      /**
       * Emitted if the user selects an item of the autocomplete result list.
       * @event input
       * @type {Object} the selected object
       */
      this.$emit('input', val)
    }
  }
}
</script>

<style scoped>

</style>
